module.exports = __webpack_public_path__ + "static/AngelaHe5-6507f7dd78e8ac79e4dac38075dc457a.png";